import DiagramIcon from './component'

export default DiagramIcon
